<template>
    <div class="asset-appendix">
        <div class="font-medium flex items-center border-b border-gray-200 dark:border-dark-5 pb-5">
            <ChevronDownIcon class="w-4 h-4 mr-2" /> {{name}}
            <button class="button button--bg bg-theme-1 text-white ml-4" @click="addHandle" v-show="uploadFlag">+添加附件 </button>
        </div>
         <div class="mt-2">
            <table class="table">
                <thead>
                    <tr class="bg-gray-200 text-gray-700">
                        <th v-for="(item1,index) in columns" :key="index" class="border-b-2 dark:border-dark-5 whitespace-no-wrap"> {{item1.title}} </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item2,index2) in data" :key="index2">
                        <td class="border-b dark:border-dark-5">{{item2.key}}</td>
                        <td class="border-b dark:border-dark-5"> {{item2.name}} </td>
                        <td class="border-b dark:border-dark-5">
                            <button class="inline-block text-theme-1 dark:border-theme-10 dark:text-theme-10" @click="checkHandle(item2,index2)">查看 </button>
                            <button class="button inline-block text-theme-1 dark:border-theme-10 dark:text-theme-10" @click="delHandle(item2,index2)" v-show="uploadFlag">删除 </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import {uploadFile} from '@/assets/js/upload.js'
import {createA} from '@/assets/js/tools.js'
export default {
    name:'assetAppendix',
    data(){
        return{
            loading:false,
            pagination: {
                total: 0,
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                showQuickJumper:true,
                showLessItems:true,
            },
            columns:[
                {
                    dataIndex: 'key',
                    key: 'key',
                    title:'编号',
                },
                {
                    title: '附件名称',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '操作',
                    dataIndex: 'btn',
                    key: 'btn',
                    scopedSlots: { customRender: 'btn' },
                },
            ],
        }
    },
    props:{
        name:{
            default:'',
            type:String
        },
        data:{
            default:function(){
                return []
            },
            type:Array
        },
        uploadFlag:{
            default:true,
            type:Boolean
        }
    },
    methods:{
        checkHandle(item,index){
            createA(item.url);
        },
        delHandle(item,index){
            this.data.splice(index,1);
            this.$emit('getAppendixList',this.data)
        },
        addHandle(){
            uploadFile(10,'*').then(res=>{
                console.log(this.data,888)
                if(this.data){
                    res.key=this.data.length+1;
                    this.data.push(res);
                    this.$emit('getAppendixList',this.data);
                }

            })
        },
    },
}
</script>

